<template>
  <div class="wrap">
    <my-header
        :current-title="['税务数字账户','发票勾选确认']"
        v-bind="$attrs"
    />
    <div class="content">
      <header>
        <span>当前税款所属期：2026年12月 </span>
        <el-text type="primary">申请信息刷新</el-text>
        <el-icon color="#409eff">
          <Refresh/>
        </el-icon>
      </header>
      <div class="item item_one">
        <p class="title">
          用票业务功能
        </p>
        <ul class="menu_list">
          <li v-for="(item,index) in list" :key="index" @click="menuClick(item)">
            <div class="img">
              <img :src="item.icon" alt="">
            </div>
            <div class="info">
              <p>{{ item.title }}</p>
              <p>{{ item.des }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="item item_two">
        <p class="title">
          增值税抵扣凭证已勾选情况
        </p>
        <div class="statis">
          <template v-for="(item,index) in statisList" :key="index">
            <div class="s-item">
              <span class="stitle">{{ item.title }}</span>
              <span class="value">{{ item.value }}</span>
              <span class="desc">{{ item.desc1 || '-' }}</span>
              <span class="desc">{{ item.desc2 || '-' }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="index-footer-box">
        <div class="copyright">
          <div style="width: 100%; display: inline-flex; align-items: center; justify-content: center">
            <img src="https://static.rhkj.com/renhe_fe/other/reportTax/copyright.png" alt="#"
                 style="height: 80px; object-fit: cover"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import myHeader from "./cmp/myHeader.vue";
import Big from "big.js";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

// 页面可能展示的统计值。
const pageShowVal = computed(() => {
  const data = {
    checkRows: [],
    verify: '否',
    ...JSON.parse(props.currentQa?.solution || "{}")
  }
  let amountTotal = new Big(0), taxAmountTotal = new Big(0), effectiveTaxAmountTotal = new Big(0)
  data.checkRows.forEach(row => {
    amountTotal = amountTotal.plus(row.amount) //金额合计
    taxAmountTotal = taxAmountTotal.plus(row.taxAmount) //税额合计
    effectiveTaxAmountTotal = effectiveTaxAmountTotal.plus(row.effectiveTaxAmount) // 有效税额合计
  })

  return {
    amountTotal: amountTotal.toFixed(2),
    taxAmountTotal: taxAmountTotal.toFixed(2),
    effectiveTaxAmountTotal: effectiveTaxAmountTotal.toFixed(2),
    fs: data.checkRows.length, //份数
  }
})

const list = ref([
  {
    title: "抵扣类勾选",
    des: '对符合规定的增值税扣税凭证进行用途确认（含农产品加计扣缴），支持变更税款所属期申请',
    icon: "data:image/svg+xml;base64,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"
  },
  {
    title: "不抵扣勾选",
    des: '对不用于进项抵扣、不用于出口退税、不用于代办出口退税等用途的增值税扣税凭证进行勾选',
    icon: "data:image/svg+xml;base64,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"
  },
  {
    title: "逾期抵扣申请",
    des: '提供对逾期发票（2016年12月31日以前）抵扣的申请，可查看审核情况',
    icon: "data:image/svg+xml;base64,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"
  },
  {
    title: "注销勾选",
    des: '办理注销业务时，本功能可提前对注销的税款所属期的增值税扣税凭证进行勾选统计确认',
    icon: "data:image/svg+xml;base64,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"
  }
])

const statisList = ref([
  {
    title: "已勾选发票税额合计（元）",
    value: `${pageShowVal.value.taxAmountTotal}`,
    desc1: `发票: ${pageShowVal.value.fs}张`,
    desc2: ''
  },
  {
    title: "已勾选海关缴款书税款合计（元）",
    value: '0.00',
    desc1: '海关缴款书: 0张',
    desc2: ''
  },
  {
    title: "已勾选代扣代缴完税凭证税额合计（张）",
    value: '0.00',
    desc1: '代扣代缴完税凭证: 0张',
    desc2: ''
  },
  {
    title: "已勾选农产品加计扣除税额合计（元）",
    value: '0.00',
    desc1: '发票：0张',
    desc2: '海关缴款书: 0张'
  }
])
const menuClick = (item) => {
  if (item.title == '抵扣类勾选') {
    emit('startAns')
  }
}
const emit = defineEmits(['startAns']);
</script>


<style scoped lang="scss">
.wrap {
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    height: calc(100% - 96px);

    padding: 0 36px;
    box-sizing: border-box;
    background-color: #f7f8fa;
    overflow-y: auto;
    overflow-x: hidden;

    header {
      display: flex;
      align-items: center;
      height: 60px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      border-radius: 4px;
      padding: 0 16px;
      box-sizing: border-box;
      margin-top: 20px;

      span {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .item {
      .title {
        font-weight: 700;
        font-size: 16px;
        height: 58px;
        padding: 0 20px;
        line-height: 58px;
        border-bottom: 1px solid #eee;
      }
    }

    .item_one {
      width: 100%;
      height: 320px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      background-color: #fff;
      margin-top: 20px;
      border-radius: 4px;

      .menu_list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 16px;
        box-sizing: border-box;

        li {
          width: 32%;
          height: 100px;
          display: flex;
          align-items: center;
          padding: 10px;
          box-sizing: border-box;
          border: 1px solid #eee;
          cursor: pointer;
          margin-bottom: 20px;

          .img {
            img {
              display: block;
              width: 56px;
              height: 56px;
            }
          }

          .info {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            p:nth-child(1) {
              margin-bottom: 16px;
              font-size: 16px;
              font-weight: bold;
              color: #303133;
            }

            P:nth-child(2) {
              color: #303133;
              font-size: 13px;
            }
          }
        }
      }
    }

    .item_two {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      background-color: #fff;
      margin-top: 20px;
      border-radius: 4px;

      .statis {
        display: flex;

        .s-item {
          width: 25%;
          display: flex;
          flex-direction: column;
          color: #303133;
          padding: 20px;
          box-sizing: border-box;

          span {
            margin-bottom: 18px;
          }

          .stitle {
            font-size: 14px;
          }

          .value {
            font-size: 28px;
          }
        }
      }
    }

    .index-footer-box {
      width: 100%;
      margin-top: 20px;
      background-color: #f1f2f3;

      .copyright {
        width: 1184px;
        padding: 21px 0;
        background: #f1f2f3;
        margin: 0 auto;
      }
    }
  }
}
</style>
